import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const contextValuesSlice = createCrudSlice({
  name: 'contextValues',
})

export const ContextValuesActions = contextValuesSlice.actions

export const ContextValuesSelectors = {
  ...createCrudSelectors({ name: 'contextValues' }),
}

export default contextValuesSlice.reducer